import { skipToken } from "@tanstack/react-query";
import { can } from "@remi/permissions";

import { api } from "~/utils/api";
import { useUserProfile } from "~/contexts/UserProfileContext";

export const useCreateQuoteTaskIdForRfq = (rfqId: number | null) => {
  const { user } = useUserProfile();
  const enabled = rfqId !== null && can.requestForQuote.read(user);
  const { data } = api.quoting.getCreateQuoteTaskIdForRfq.useQuery(enabled ? rfqId : skipToken, {
    refetchInterval: 1000 * 30,
  });
  return data ?? undefined;
};
